<!--Navigation Bar-->
<app-navbar>
    <h2>{{'AGRI_SERVICES.TITLE' | translate}}</h2>
</app-navbar>
<div class="services-section light-grey-background ptb-70">
    <section class="mb-5">
        <div class="container">
             <div class="row">
            <h3 class="custom-section-title">{{'AGRI_SERVICES.RECRUITING_TITLE' | translate}}</h3>
            <p [innerHTML]="'AGRI_SERVICES.RECRUITING_HTML' | translate"></p>
        </div>
        </div>
    </section>

    <section class="mb-5">
        <div class="container">
            <div class="row">
                <h3 class="custom-section-title">{{'AGRI_SERVICES.SPECIALIST_TITLE' | translate}}</h3>
                <p [innerHTML]="'AGRI_SERVICES.SPECIALIST_HTML' | translate"></p>
            </div>
        </div>
    </section>

    <section class="mb-5">
        <div class="container">
            <div class="row">
                <h3 class="custom-section-title">{{'AGRI_SERVICES.JUNIOR_TITLE' | translate}}</h3>
                <p [innerHTML]="'AGRI_SERVICES.JUNIOR_HTML' | translate"></p>
            </div>
        </div>
    </section>
    

    <section class="mb-5">
        <div class="container">
            <div class="row">
                <h3 class="custom-section-title">{{'AGRI_SERVICES.EVALUATION_TITLE' | translate}}</h3>
                <p [innerHTML]="'AGRI_SERVICES.EVALIATION_HTML' | translate"></p>
            </div>
        </div>
    </section>

    <section class="mb-5">
        <div class="container">
            <div class="row">
                <h3 class="custom-section-title">{{'AGRI_SERVICES.TESTING_TITLE' | translate}}</h3>
                <p [innerHTML]="'AGRI_SERVICES.TESTING_HTML' | translate"></p>
            </div>
        </div>
    </section>

    <section class="mb-5">
        <div class="container">
            <div class="row">
                <h3 class="custom-section-title">{{'AGRI_SERVICES.E_LEARNING_TITLE' | translate}}</h3>
                <p [innerHTML]="'AGRI_SERVICES.E_LEARNING_HTML' | translate"></p>
            </div>
        </div>
    </section>

    <section class="mb-5">
        <div class="container">
            <div class="row">
                <h3 class="custom-section-title">{{'AGRI_SERVICES.SALARY_TITLE' | translate}}</h3>
                <p [innerHTML]="'AGRI_SERVICES.SALARY_HTML' | translate"></p>
            </div>
        </div>
    </section>

    <section>
        <div class="container">
            <div class="row">
                <h3 class="custom-section-title">{{'AGRI_SERVICES.MARKET_REASERSH_TITLE' | translate}}</h3>
                <p [innerHTML]="'AGRI_SERVICES.MARKET_REASERSH_HTML' | translate"></p>
            </div>
        </div>
    </section>
</div>

<!--Footer-->
<app-footer></app-footer>